module.exports = __webpack_public_path__ + "img/sm3_maskFIT_m.b2061cb1.png";